import React, { useState, useEffect } from "react";

const StaffAppliedFilters = ({ pagename="" }) => {
    const [filters, setFilters] = useState({});
    // Function to fetch and process filters from sessionStorage
    const getAppliedFilters = () => {
        const keys = ["Year", "SchoolType", "Gender", "Ethincity", "Grade", "Schoolname","EL","Free and Reduced Lunch","Students with Disabilities"];
        let appliedFilters = {};

        keys.forEach((key) => {
            const value = JSON.parse(sessionStorage.getItem(key)) ?? 2027;
            if(key == 'Year') {
                const isNum = Number(value);
                appliedFilters[key] = `${isNum - 1}-${isNum}` 
            }
            // Only add non-empty values
            if (key != 'Year' && value && value?.length > 0) {
                appliedFilters[key] = value;
            }
        });

        return appliedFilters;
    };

    useEffect(() => {
        const updateFilters = () => {
            setFilters(getAppliedFilters());
        };

        // Fetch filters initially
        updateFilters();

        // Listen for storage changes
        const handleStorageChange = (e) => {
            if (["Year", "SchoolType", "Gender", "Ethincity", "Grade", "Schoolname","EL","Free and Reduced Lunch","Students with Disabilities"].includes(e.key)) {
                updateFilters();
            }
        };

        window.addEventListener("storage", handleStorageChange);

        // Override sessionStorage.setItem to trigger updates in the same tab
        const originalSetItem = sessionStorage.setItem;
        sessionStorage.setItem = function (key, value) {
            originalSetItem.apply(this, [key, value]);
            window.dispatchEvent(new StorageEvent("storage", { key }));
        };

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            sessionStorage.setItem = originalSetItem; // Cleanup
        };
    }, []);

    return (
        <div className="flex items-center gap-1">
            <h3 className="text-[14px] font-semibold text-white ">Applied Filter :</h3>
            {Object.keys(filters).length > 0 ? (
                <ul className="flex flex-wrap items-center gap-2">
                    {Object.entries(filters).map(([key, value]) => (
                        <li key={key} className="flex gap-1 items-center bg-[#F2F7F9] text-[14px] font-medium text-[#2D3D4C] px-3 py-1 rounded-[8px]">
                            {key}:
                            {Array.isArray(value) ? (
                                <ul className="flex gap-1">
                                    {value.map((item, index) => (
                                        <li key={index} className="flex items-center">
                                            {typeof item === "object" && item.label ? (
                                                <span className="mr-1">{item.label}</span>
                                            ) : (
                                                <span className="mr-1">{item}</span>
                                            )}
                                            {index < value.length - 1 && <span className="text-gray-400">|</span>}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <span>{value}</span>
                            )}
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="flex items-center bg-blue-100 text-blue-700 px-2  rounded-full shadow-sm ">Year:2024-2025</p>
            )}
        </div>
    );
};

export default StaffAppliedFilters;
